// A customer's routing rule saved (`routing-rule`): the hook over `rule-writer.ts` — the person's
// logged writes, the platform's client and the signed-in name.

import { crudApi, crudErrorText, useMe } from "@axny/platform-ui";
import { useLoggedWrites } from "./logged-write";
import { ruleWriter } from "./rule-writer";

export type { RuleTarget } from "./rule-writer";

export function useRuleWrites() {
  const writes = useLoggedWrites();
  const me = useMe();
  const who = me.data?.authenticated ? me.data.user.displayName || me.data.user.username : "";
  return ruleWriter({ writes, get: (entity, id) => crudApi.get(entity, id), who, errorText: crudErrorText });
}
